import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/guidelines.js"

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>

<MDXTag name="blockquote" components={components}>
<MDXTag name="p" components={components} parentName="blockquote">{`Anything is possible on a white background. Use a colour and you are in a box before you have started.`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`The intention is to transition Tes Portal and Tes.com to a white background on all pages.`}</MDXTag></MDXTag>
<MDXTag name="p" components={components}>{`The current blue background limits the squads in the type of content and colour they can use on a page without clashing with the background.`}</MDXTag>
<MDXTag name="p" components={components}>{`We will achieve this by changing the background colour of all new pages we build; and on any page where we make substantial updates.`}</MDXTag>
<MDXTag name="p" components={components}>{`All existing pages will be left with a blue background until they are in a minority and we can be sure they will not be adversely affected by the change.`}</MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  